import { useState } from "react";
import "../Login/Login.scss";
import ButtonComponent from "../../components/ButtonComponent/ButtonComponent";
import InputField from "../../components/InputField/InputField";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { errorToast, successToast } from "../../services/ToastHelper";
import { RESET_PASSWORD } from "../../utils/apiPath";
import { postApi } from "../../utils/apiService";

import AuthLogo from "../../assets/appLogo";

const initialValues = {
  email: "",
  password: "",
  confirmPassword: "",
};

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const emailParam = searchParams.get("email") || "";

  const [form, setForm] = useState({ ...initialValues, email: emailParam });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateFields = () => {
    const newErrors = {};

    if (!form.email) {
      newErrors.email = "Email is required";
    } else if (/\s/.test(form.email)) {
      newErrors.email = "Email should not contain spaces";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!form.password) {
      newErrors.password = "Password is required";
    } else if (/\s/.test(form.password)) {
      newErrors.password = "Password should not contain spaces";
    } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(form.password)) {
      newErrors.password = "Password must be 8+ characters, with uppercase, lowercase, number, and special character.";
    }

    if (!form.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (!token) {
      errorToast("Invalid or missing reset token");
      return false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetPassword = async () => {
    if (!validateFields()) return;

    setIsLoading(true);
    try {
      const payload = { 
        email: form.email, 
        token: token, 
        password: form.password 
      };
      const { statusCode, message } = await postApi(RESET_PASSWORD, payload);

      if (statusCode === 200) {
        successToast("Password reset successfully! You can now log in.");
        navigate("/");
      } else {
        errorToast(message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {isLoading && <Loader />}

      <div className="login-wrap">
        <div className="login-logo">
          <img src={AuthLogo} alt="main-logo" />
        </div>

        <div className="login-card">
          <h1 className="title">Reset Password</h1>
          <p className="subtitle">Enter your new password below</p>

          <div className="form">
            <InputField
              title="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              disabled={!!emailParam} // Disable if it comes from URL
              errorText={errors.email}
            />

            <InputField
              title="New Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Enter new password"
              required
              errorText={errors.password}
            />

            <InputField
              title="Confirm Password"
              name="confirmPassword"
              type="password"
              value={form.confirmPassword}
              onChange={handleChange}
              placeholder="Confirm new password"
              required
              errorText={errors.confirmPassword}
              onKeyDown={(e) => e.key === "Enter" && handleResetPassword()}
            />

            <ButtonComponent type="submit" variant="primary" onClick={handleResetPassword}>
              Reset Password
            </ButtonComponent>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <span 
                className="link" 
                style={{ cursor: "pointer" }} 
                onClick={() => navigate("/")}
              >
                Back to Login
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
